import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { KioskService } from '../kiosk.service';
import { forkJoin } from 'rxjs';
import { LicenseService } from '../license.service';

@Component({
  selector: 'app-kiosk-decommission-dialog',
  templateUrl: './kiosk-decommission-dialog.component.html',
  styleUrls: ['./kiosk-decommission-dialog.component.css']
})
export class KioskDecommissionDialogComponent implements OnInit {
  loading = false;
  resp: any;
  constructor(
    public dialogRef: MatDialogRef<KioskDecommissionDialogComponent>,
    private _kioskService: KioskService,
    private _licenseService: LicenseService,
    public snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { kiosk: any }) { }


  ngOnInit() {
  }

  decommissionKiosk() {
    console.log(this.data.kiosk);

    const licenseSubs = this.data.kiosk.licenses
      .filter((l) => l.type === 'HEARKIOSK.DIN' || l.type === 'HEARKIOSK.PTA')
      .map((l) => this._licenseService.DelinkDeviceFromLicense(l.id));


    forkJoin(this._kioskService.decommissionKiosk(this.data.kiosk.id), ...licenseSubs).subscribe(_ => {
      this.loading = false;
      this.dialogRef.close('refresh');
    }, (error) => {
      this.loading = false;
      this.snackBar.open('Error:' + error.error, 'Okay', {
        duration: 2000,
      });
    });

  }
}



// WEBPACK FOOTER //
// ./src/app/kiosk-decommission-dialog/kiosk-decommission-dialog.component.ts